var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9ca3af",
    width: "96px",
    height: "96px",
    viewBox: "-0.24 -0.24 2.88 2.88",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin",
    className: "jam jam-google",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.525 0.968A0.72 0.72 0 0 0 0.487 1.2c0 0.088 0.016 0.172 0.045 0.25a0.714 0.714 0 0 0 1.028 0.365h0a0.715 0.715 0 0 0 0.308 -0.365H1.226V0.976h1.153a1.2 1.2 0 0 1 -0.005 0.475 1.2 1.2 0 0 1 -0.422 0.685A1.195 1.195 0 0 1 1.2 2.4 1.2 1.2 0 0 1 0.134 0.648 1.2 1.2 0 0 1 1.2 0c0.291 0 0.558 0.104 0.766 0.276l-0.389 0.318a0.714 0.714 0 0 0 -1.052 0.374"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.da2cdd975f03f14a146ca007e4eda6a0.svg";
export { ForwardRef as ReactComponent };